import React from 'react';
import { Content, Panel } from 'rsuite';
import * as PERMISSIONS from '../../../../constants/permissions/settings';
import { viewAccess } from '../../../../helpers/permission';
import AccessControl from '../../../../components/AccessControl';
import AccessDenied from '../../../../components/AccessDenied';
import PageHeader from '../../../../components/PageHeader';
import PageLayout from '../../../../components/settings/portal/PageLayout';
import PortalUserList from '../../../../components/settings/portal/UserList';
import PortalUserSearch from '../../../../components/settings/portal/UserSearch';

export default () => (
  <PageLayout>
    <AccessControl
      allowOnlyFor={viewAccess(PERMISSIONS.PORTAL)}
      fallback={<AccessDenied />}
    >
      <PageHeader title="Portal Guests">
        <Panel bordered>
          <PortalUserSearch placeholder="Search by Portal Name or Email" />
        </Panel>
      </PageHeader>
      <Content>
        <PortalUserList />
      </Content>
    </AccessControl>
  </PageLayout>
);
